import React from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import Sound from 'react-sound';
import UIFx from 'uifx';

import { useImagesContext } from '../../contexts/ImagesContext';
import { DivClick, ImgClick } from '../utility';
import ChoosePower from './ChoosePower';
import { POWER_TYPES } from '../../constant';
import { setPowerType as setPowerTypeService } from '../../services/student_props';
import {
  setSelectStudent,
  setStudentProblemState,
} from '../../actions/student';
import {
  // getAmulets,
  // getSelectAmulets,
  setSelectAmulets,
  getLearnFightStats,
} from '../../services/student_collection';
import { StudentPowerText } from './StudentPowerText';

import tutorialSoundFile from './sounds/tutorial.mp3';
import { setAmulets, setRemembers } from '../../actions/learn-fight';
import { Delay } from '../../utils/delay';
import backgroundSound from './sounds/backgroud.mp3';
import selectAmuletFile from './sounds/select-amulet.mp3';
import gotHiddenPowerFile from './sounds/got-hidden-power.mp3';

// const tutorialSound = new UIfx(tutorialSoundFile);
const selectAmulet = new UIFx(selectAmuletFile);

const PAGES = {
  main: 'main',
  choosePower: 'choosePower',
};

const GamePowerBlock = ({ powerType, powerValue, images }) => {
  return (
    <GamePowerItemBlock>
      <GamePowerItemImg
        src={
          images[
            powerValue > 0
              ? `power-${powerType}${powerValue}.png`
              : 'power-none.png'
          ]
        }
        alt=""
      />
      <GamePowerItemText>{powerValue > 0 ? powerValue : '-'}</GamePowerItemText>
    </GamePowerItemBlock>
  );
};

const GamePowerItemBlock = styled.div`
  text-jusitfy: center;
  height: 129px;
`;

const GamePowerItemImg = styled.img`
  display: block;
  margin: 0 auto;
`;

const GamePowerItemText = styled.span`
  position: absolute;
  // border: 1px solid black;
  font-family: PSLxText;
  font-weight: bold;
  // font-size: 24px;
  font-size: 32px;
  color: white;
  margin-left: 75px;
  margin-top: -8px;
`;

function isUpdated(oldData, newData) {
  if (oldData.length !== newData.length) {
    return true;
  }
  for (let i = 0; i < oldData.length; i++) {
    if (newData.findIndex((v) => oldData[i].number !== v.number) >= 0) {
      return true;
    }
  }
  return false;
}

const CollectionRoom = ({
  student,
  setSelectStudent,
  history,
  setAmulets,
  amulets,
  setRemembers,
  remembers,
  config,
}) => {
  const { images } = useImagesContext();
  const [powerType, setPowerType] = React.useState(student.powerType);
  const [itemSlots, setItemSlots] = React.useState([null, null]);
  const [chooseHiddenPower, setChooseHiddenPower] = React.useState(false);
  const [chooseItemSlot, setChooseItemSlot] = React.useState(null);
  const [gameCabinetPower, setGameCabinetPower] = React.useState(null);
  const [studentPower, setStudentPower] = React.useState(null);
  const [playTutorial, setPlayTutorial] = React.useState(false);
  const [currentAmulets, setCurrentAmulets] = React.useState([]);
  const [currentRemembers, setCurrentRemembers] = React.useState([]);
  const [hiddenPower, setHiddeenPower] = React.useState(null);
  const [yardnapha, setYardnapha] = React.useState(null);
  const [hiddenPowerIncrease, setHiddenPowerIncrease] = React.useState(0);

  let page = PAGES.main;
  if (chooseHiddenPower) {
    page = PAGES.choosePower;
  }

  console.debug('currentAmulets', currentAmulets);
  console.debug('currentRemembers', currentRemembers);

  const getData = async () => {
    // const retAmulets = await getAmulets(student.id);
    // setAmulets(retAmulets.data);
    // const retSelectAmulets = await getSelectAmulets(student.id);
    // setItemSlots(retSelectAmulets.data.map((item) => item.number));
    const retLearnFightStats = await getLearnFightStats(student.id);
    const retAmulets = retLearnFightStats.data.studentAmulets;
    for (let i = 0; i < retAmulets.length; i++) {
      if (
        amulets.find((v) => retAmulets[i].number === v.number) === undefined
      ) {
        retAmulets[i].isNew = true;
      } else {
        retAmulets[i].isNew = false;
      }
    }
    setCurrentAmulets(retAmulets);
    const retRemembers = retLearnFightStats.data.studentRememers;
    for (let i = 0; i < retRemembers.length; i++) {
      if (
        remembers.find((v) => retRemembers[i].number === v.number) === undefined
      ) {
        retRemembers[i].isNew = true;
      } else {
        retRemembers[i].isNew = false;
      }
    }
    setCurrentRemembers(retRemembers);
    const tmpResItemSlots = retLearnFightStats.data.studentAmuletsSelected;
    const tmpItemSlots = [null, null];
    for (let i = 0; i < 2; i++) {
      const found = tmpResItemSlots.find((item) => item.slotNumber === i + 1);
      tmpItemSlots[i] = found ? found.number : null;
    }
    setItemSlots(tmpItemSlots);
    setGameCabinetPower(retLearnFightStats.data.gameCabinetPower);
    setStudentPower(retLearnFightStats.data.studentPower);
    console.debug('new hidenPower', retLearnFightStats.data.hiddenPower);
    console.debug('old hidenPower', student.hiddenPower);
    if (
      student.hiddenPower >= 0 &&
      retLearnFightStats.data.hiddenPower > student.hiddenPower
    ) {
      let tmpHiddenPower = student.hiddenPower;
      while (tmpHiddenPower < retLearnFightStats.data.hiddenPower) {
        setHiddeenPower(tmpHiddenPower);
        setHiddenPowerIncrease(
          retLearnFightStats.data.hiddenPower - tmpHiddenPower
        );
        tmpHiddenPower += 1;
        await Delay(2000);
        setHiddenPowerIncrease(null);
        await Delay(500);
      }
      setSelectStudent({
        ...student,
        hiddenPower: retLearnFightStats.data.hiddenPower,
      });
    }
    setHiddeenPower(retLearnFightStats.data.hiddenPower);
    setYardnapha(retLearnFightStats.data.yardnapha);
    setHiddenPowerIncrease(null);
  };

  React.useEffect(() => {
    getData();
  }, []);

  console.debug('studentRemembers', remembers);

  const handleBack = () => {
    for (let i = 0; i < currentAmulets.length; i++) {
      if (currentAmulets[i].isNew) {
        setAmulets(
          currentAmulets.map((v) => ({
            number: v.number,
          }))
        );
        break;
      }
    }
    for (let i = 0; i < currentRemembers.length; i++) {
      if (currentRemembers[i].isNew) {
        setRemembers(
          currentRemembers.map((v) => ({
            number: v.number,
          }))
        );
        break;
      }
    }
    history.goBack();
  };

  console.debug('student', student);

  return (
    <Container>
      {page === PAGES.main && (
        <>
          <Background src={images['background.jpg']}></Background>
          {powerType === null && (
            <>
              <LeftPanel src={images['before-choose.png']} />
              <ChooseHiddenPower
                onClick={() => setChooseHiddenPower(true)}
                src={images['choose-power.png']}
              />
            </>
          )}
          {powerType === POWER_TYPES.atk && (
            // <LeftPanel src={images['power-atk.png']} />
            <PowerImage src={images['atk.png']} />
          )}
          {powerType === POWER_TYPES.def && (
            // <LeftPanel src={images['power-def.png']} />
            <PowerImage src={images['def.png']} />
          )}
          {powerType === POWER_TYPES.hp && (
            // <LeftPanel src={images['power-hp.png']} />
            <PowerImage src={images['hp.png']} />
          )}
          <AmuletBlock>
            {Array.from(Array(12).keys()).map((index) => {
              const amuletNumber = index + 1;
              let isNew = false;
              const found = currentAmulets.find(
                (amulet) => amulet.number === amuletNumber
              );
              if (found) {
                isNew = found.isNew;
              }
              return (
                <AmuletItem key={`amulet_${index}`}>
                  <AmuletImage
                    onClick={() => {
                      if (
                        chooseItemSlot === null ||
                        itemSlots.includes(amuletNumber)
                      )
                        return;
                      if (!config.isMutedSound) selectAmulet.play();
                      itemSlots[chooseItemSlot - 1] = amuletNumber;
                      setSelectAmulets(
                        student.id,
                        amuletNumber,
                        chooseItemSlot
                      ).then((value) => {
                        console.debug('setSelectAmulets', value.data);
                        // itemSlots.sort((a, b) => a.slotNumber - b.slotNumber);
                        // setItemSlots([...itemSlots]);
                        setChooseItemSlot(null);
                        getData();
                      });
                    }}
                    $active={
                      chooseItemSlot != null &&
                      !itemSlots.includes(amuletNumber)
                    }
                    $display={found}
                    src={
                      images[`amulet_${String(index + 1).padStart(2, '0')}.png`]
                    }
                    key={index}
                  />
                  <AmuletNewItem
                    $display={isNew}
                    src={images['collection-new.png']}
                  />
                </AmuletItem>
              );
            })}
          </AmuletBlock>
          <RememberBlock>
            {Array.from(Array(12).keys()).map((index) => {
              let isNew = false;
              const found = currentRemembers.find(
                (remember) => remember.number === index + 1
              );
              if (found) {
                isNew = found.isNew;
              }
              return (
                <RememberItem $display={found}>
                  <RememberImage
                    src={
                      images[
                        `remember_${String(index + 1).padStart(2, '0')}.png`
                      ]
                    }
                    key={`remember_${index + 1}`}
                  />
                  <RememberNewItem
                    $display={isNew}
                    src={images['collection-new.png']}
                  />
                </RememberItem>
              );
            })}
          </RememberBlock>
          <ChooseItemBG src={images['item-tags.png']} />
          {powerType !== null && (
              <ChooseItemBlock>
                {itemSlots.map((amuletId, index) => (
                  <ChooseItem
                    onClick={() => {
                      if (!config.isMutedSound) selectAmulet.play();
                      if (chooseItemSlot === index + 1) setChooseItemSlot(null);
                      else setChooseItemSlot(index + 1);
                    }}
                  >
                    <ChooseItemImage src={images['choose-item-border.png']} />
                    {amuletId != null && (
                      <ItemImage
                        src={
                          images[
                            `amulet_${String(amuletId).padStart(2, '0')}.png`
                          ]
                        }
                      />
                    )}
                  </ChooseItem>
                ))}
              </ChooseItemBlock>
          )}
          {powerType !== null && (
            <>
              <AttributeBlock $bg={images['boss-item-block.png']}>
                <div style={{ height: 45 }}></div>
                <GamePowerBlock
                  powerType="hp"
                  powerValue={gameCabinetPower ? gameCabinetPower.hp : 0}
                  images={images}
                />
                <GamePowerBlock
                  powerType="atk"
                  powerValue={gameCabinetPower ? gameCabinetPower.atk : 0}
                  images={images}
                />
                <GamePowerBlock
                  powerType="def"
                  powerValue={gameCabinetPower ? gameCabinetPower.def : 0}
                  images={images}
                />
                <GamePowerBlock
                  powerType="all"
                  powerValue={gameCabinetPower ? gameCabinetPower.all : 0}
                  images={images}
                />
              </AttributeBlock>
              <StudentPowerText power={studentPower} />
              <HiddenPower $background={images['hidden-power.png']}>
                {hiddenPower && (
                  <HiddenPowerText>
                    {hiddenPower && hiddenPower > 0 ? `${hiddenPower}%` : '-'}
                  </HiddenPowerText>
                )}
              </HiddenPower>
              <HiddenPowerGoten
                src={
                  hiddenPowerIncrease > 0
                    ? images['hidden-power-goten.png']
                    : null
                }
                alt=""
              />
              {hiddenPowerIncrease > 0 && (
                <Sound
                  url={gotHiddenPowerFile}
                  playStatus="PLAYING"
                  loop={false}
                  volume={config.isMutedSound ? 0 : 100}
                ></Sound>
              )}
              {/* <HiddenPower>2%</HiddenPower> */}
              {student && (
                <YardnaphaBlock $background={images['yardnapha.png']}>
                  <YardnaphaBlockText>
                    {yardnapha && yardnapha > 0 ? `${yardnapha}` : '-'}
                  </YardnaphaBlockText>
                </YardnaphaBlock>
              )}
            </>
          )}
          {playTutorial && (
            <>
              <TutorialAnimation src={images['tutorial.png']} alt="" />
              <Sound
                url={tutorialSoundFile}
                playStatus={Sound.status.PLAYING}
                onFinishedPlaying={() => {
                  setPlayTutorial(false);
                }}
              />
            </>
          )}
          <SoundButton
            onClick={() => {
              setPlayTutorial((value) => !value);
            }}
            src={images['sound.png']}
          />
          <Back onClick={handleBack} src={images['home.png']} />
        </>
      )}
      {page === PAGES.choosePower && (
        <ChoosePower
          handleSelectd={(powerType) => {
            setPowerTypeService(student.id, powerType).then((value) => {
              console.debug('setPowerTypeService', value.data);
              setSelectStudent({ ...student, powerType: value.data.powerType });
              setPowerType(value.data.powerType);
              setChooseHiddenPower(false);
              getData();
            });
          }}
          handleBack={() => setChooseHiddenPower(false)}
        />
      )}
      <Sound
        url={backgroundSound}
        playStatus="PLAYING"
        loop={true}
        volume={config.isMutedSound ? 0 : 100}
      ></Sound>
    </Container>
  );
};

const AttributeBlock = styled.div`
  background-image: url(${(props) => props.$bg});
  position: absolute;
  left: 8px;
  top: 390px;
  width: 122px;
  height: 560px;
  // padding-top: 45px;
  justify-content: center;
  // border: 1px solid red;
`;

const FullScreenImg = styled.img`
  width: 1920px;
  height: 1080px;
  position: absolute;
  left: 0;
  top: 0;
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const TutorialAnimation = styled.img`
  animation: ${fadeIn} 3s ease-in-out;
  width: 1920px;
  height: 1080px;
  position: absolute;
  left: 0;
  top: 0;
`;

const Container = styled.div`
  width: 1920px;
  height: 1080px;
  position: relative;
`;

const Background = styled.img`
  top: 0px;
  left: 0px;
  width: 1920px;
  height: 1080px;
  position: absolute;
  object-fit: contain;
`;

const LeftPanel = styled.img`
  position: absolute;
  top: 0;
  left: 0;
`;

const PowerImage = styled.img`
  position: absolute;
  bottom: 10px;
  left: 140px;
`;

const ChooseHiddenPower = styled(ImgClick)`
  position: absolute;
  top: 550px;
  left: 180px;
`;

const AmuletImage = styled.img`
  ${(props) => {
    if (!props.$display) {
      return `
      visibility: hidden;
      `;
    }
    if (props.$active) {
      return `
        filter: drop-shadow(0 0 10px #fff);
        &:hover {
            transform: scale(1.06);
            filter: drop-shadow(0 0 10px #fff);
        }
      `;
    }
  }}
`;

const AmuletItem = styled.div`
  // border: 1px solid red;
  position: relative;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const AmuletBlock = styled.div`
  // border: 1px solid red;
  position: absolute;
  top: 95px;
  left: 800px;
  display: flex;
  flex-wrap: wrap;
  width: 450px;
  justify-content: space-evenly;
`;

const AmuletNewItem = styled.img`
  visibility: ${(props) => (props.$display ? 'visible' : 'hidden')};
  display: block;
  margin: 0 auto;
`;

// const RememberImage = styled(ImgClick)`
const RememberImage = styled.img`
  // filter: opacity(30%);
`;

const RememberItem = styled.div`
  visibility: ${(props) => (props.$display ? 'visible' : 'hidden')};
  // border: 1px solid red;
  position: relative;
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const RememberBlock = styled.div`
  // border: 1px solid red;
  position: absolute;
  top: 95px;
  left: 1280px;
  display: flex;
  flex-wrap: wrap;
  width: 450px;
  justify-content: space-evenly;
`;

const RememberNewItem = styled.img`
  visibility: ${(props) => (props.$display ? 'visible' : 'hidden')};
  display: block;
  margin: 0 auto;
`;

const Back = styled(ImgClick)`
  position: absolute;
  top: 8px;
  left: 8px;
`;

const SoundButton = styled(ImgClick)`
  position: absolute;
  bottom: 0px;
  right: 40px;
`;

const ChooseItemBG = styled.img`
  position: absolute;
  top: 8px;
  left: 56px;
`;

const ChooseItemBlock = styled.div`
  // border: 1px solid red;
  position: absolute;
  top: 170px;
  left: 100px;
  display: flex;
  width: 400px;
  justify-content: space-evenly;
`;

const ChooseItem = styled(DivClick)`
  width: 144px;
  height: 144px;
`;

const ChooseItemImage = styled.img`
  position: absolute;
  width: 144px;
  height: 144px;
`;

const ItemImage = styled.img`
  position: absolute;
  width: 144px;
  height: 144px;
  object-fit: contain;
`;

const HiddenPower = styled.div`
  background-image: url(${(props) => props.$background});
  width: 144px;
  height: 144px;
  position: absolute;
  bottom: 0px;
  left: 400px;
`;

const HiddenPowerText = styled.span`
  font-family: PSLxText;
  font-weight: bold;
  font-size: 60px;
  color: white;
  paint-order: stroke fill;
  -webkit-text-stroke: 0.05em black;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const HiddenPowerGoten = styled.img`
  position: absolute;
  bottom: 12px;
  left: 402px;
`;

const YardnaphaBlock = styled.div`
  background-image: url(${(props) => props.$background});
  background-size: contain;
  width: 100px;
  height: 100px;
  position: absolute;
  bottom: 0px;
  right: 600px;
`;

const YardnaphaBlockText = styled.span`
  font-family: PSLxText;
  font-weight: bold;
  font-size: 50px;
  color: white;
  paint-order: stroke fill;
  -webkit-text-stroke: 0.05em black;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const mapStateToProps = ({ student, learnFight, config }) => ({
  student,
  questions: learnFight.questions,
  amulets: learnFight.amulets,
  remembers: learnFight.remembers,
  config,
});

const mapDispatchToProps = {
  setRemembers,
  setAmulets,
  setSelectStudent,
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionRoom);
